// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"validate-oab-modal-with-provider_modalContent__cp0MY"};